__turbopack_context__.v({
  "content": "ProductSelection-module__RbT7na__content",
  "dimmed": "ProductSelection-module__RbT7na__dimmed",
  "header-content": "ProductSelection-module__RbT7na__header-content",
  "productHeader": "ProductSelection-module__RbT7na__productHeader",
  "root": "ProductSelection-module__RbT7na__root",
  "stickyPanel": "ProductSelection-module__RbT7na__stickyPanel",
});
